<script setup lang="ts">
import { Tabbar, TabbarItem } from 'vant';
import { computed } from 'vue';
import { $t } from '@/locales';
import { useRouter } from 'vue-router';
import {
  processFabricProperty,
  cloudKnitFabricReg,
  cloudKnitReg,
  oldCloudKnitReg
} from '@/utils';

const props = defineProps<{ qrCode?: string }>();

const isValidUrl = (url: string) => cloudKnitFabricReg.test(url) || cloudKnitReg.test(url) || oldCloudKnitReg.test(url);
const valid = computed(() => props.qrCode && isValidUrl(props.qrCode));

const router = useRouter();
const onClick = async () => {
  if (!props.qrCode) {
    return;
  }

  const lastRoute = JSON.parse(localStorage.getItem('lastRoute') || '{}');
  const { params, query } = lastRoute;

  if (cloudKnitReg.test(props.qrCode) || oldCloudKnitReg.test(props.qrCode)) {
    const match = props.qrCode.match(cloudKnitReg) || props.qrCode.match(oldCloudKnitReg);
    if (match && match[1]) {
      const id = match[1];
      await router.push({
        name: 'fabric',
        params: { id: 'default', ...params },
        query: {
          ...query,
          scoId: id,
          originScoUrl: btoa(props.qrCode)
        }
      });

    }
  } else if (cloudKnitFabricReg.test(props.qrCode)) {
    const params = await processFabricProperty(props.qrCode);
    await router.push({
      name: 'fabric',
      params: { ...params },
      query: {
        ...query,
        originUrl: btoa(props.qrCode),
        color: undefined
      }
    });
  }
};

const onBack = () => {
  router.back();
};
</script>

<template>
  <Tabbar placeholder route safe-area-inset-bottom>
    <TabbarItem class="tabbar-item" @click="onBack">
      {{ $t('common.return') }}
    </TabbarItem>
    <TabbarItem class="tabbar-item" v-if="valid" @click="onClick">
      应用
    </TabbarItem>
  </Tabbar>
</template>

<style scoped>
.tabbar-item {
  font-size: 16px;
}
</style>
